import {Avatar, Box, IconButton, Typography} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import {UserBadge} from "../../../component/user/UserBadge";
import {AddressBadge} from "../../../component/address/AddressBadge";

export const renderClientAvatar = (row) => (
    <Avatar sx={{height: 40, width: 40, backgroundColor: '#565656'}} alt={row.company_name} src={row.company_logo_url || undefined}>
        {!row.company_logo_url && <BusinessOutlinedIcon sx={{color: '#C7CCD0'}}/>}
    </Avatar>
);

const ActionItem = ({onClick, icon, label}) => (
    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <IconButton onClick={onClick}>{icon}</IconButton>
        <Typography sx={{color: '#FFFFFF', fontSize: 12}}>{label}</Typography>
    </Box>
);

export const renderPrimaryContact = (row) => {
    const user = row.linked_users?.[0];
    if (!user) return <Typography sx={{color: '#BABABA', fontSize: 12}}>—</Typography>;
    return (
        <UserBadge
            value={{
                first_name:    user.first_name,
                last_name:     user.last_name,
                email:         user.email,
                phone_number:  user.phone_number,
                mobile_number: user.mobile_number,
            }}
            canToggle={false}
            size="sm"
        />
    );
};

export const renderContactAddress = (row) => {
    if (!row.contact_address) return <Typography sx={{color: '#BABABA', fontSize: 12}}>—</Typography>;
    return (
        <AddressBadge
            value={row.contact_address}
            fields={["address_line_1", "postal_code", "city", "state", "country"]}
            canToggle={false}
            size="sm"
        />
    );
};

export const renderClientActions = (row, {handleEdit, handleCreateJob, handleDelete} = {}) => {
    const canDelete = row.order_count === 0 && row.user_count === 0;
    return (
        <>
            <ActionItem
                onClick={() => handleEdit && handleEdit(row)}
                icon={<EditOutlinedIcon sx={{color: '#FFFFFF', '&:hover': {color: '#FFC540'}}}/>}
                label="Edit"
            />
            <ActionItem
                onClick={() => handleCreateJob && handleCreateJob(row)}
                icon={<WorkOutlineIcon sx={{color: '#FFFFFF', '&:hover': {color: '#FFC540'}}}/>}
                label="Create Job"
            />
            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', opacity: canDelete ? 1 : 0.3}}>
                <IconButton onClick={() => canDelete && handleDelete && handleDelete(row)} disabled={!canDelete}>
                    <DeleteIcon sx={{color: '#FFFFFF', '&:hover': {color: '#FFC540'}}}/>
                </IconButton>
                <Typography sx={{color: canDelete ? '#FFFFFF' : '#888888', fontSize: 12}}>Delete</Typography>
            </Box>
        </>
    );
};
